import { useCallback, useEffect, useState } from "react";
import { Header, ScrollProps } from "../../components/Header";
import {
    Container,
    TitlePage,
    ContentHeader,
    ComplementHeader,
    ContentHeaderMobile
} from "./styles";
import { IBuildigCategory, IBuildindCorretor } from "../../types";
import { CardInfo } from "../../components/CardInfo";
import { useNavigate, useParams } from "react-router-dom";
import { IoChevronBackOutline } from "react-icons/io5";
import { LoadSpinner2 } from "../../components/LoadSpinner2";
import { useAuth } from "../../context/auth";
import { SadAnimation } from "../../components/SadAnimation";
import { GoToTop } from "../../GoToTop";
import { useSearch } from "../../context/search";
import { Footer } from "../../components/Footer";

export function SearchResultCategory() {
    const navigate = useNavigate();
    const { user, api } = useAuth();
    const { resetFilters } = useSearch();
    const { id } = useParams();

    const backToTheHome = useCallback(() => {
        resetFilters();
        navigate('/');
    }, [resetFilters, navigate]);

    const [scrollTop, setScrollTop] = useState<ScrollProps>({ y: 0, lastY: 0 } as ScrollProps);
    const [show, setShow] = useState(false);

    const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
        const scrollTopVal = event.currentTarget.scrollTop;
        setScrollTop((prevState) => ({ y: scrollTopVal, lastY: prevState.y }));
    };

    const [loading, setLoading] = useState(false);
    const [building, setBuilding] = useState<IBuildindCorretor[]>([]);
    const [categorys, setCategorys] = useState<IBuildigCategory[]>([]);

    const loadCategorys = useCallback(async () => {
        await api.get('/portal/category').then((res) => {
            setCategorys(res.data);
        }).catch((e) => console.log(e));
    }, [api]);

    useEffect(() => { loadCategorys(); }, [loadCategorys]);

    const loadBuildings = useCallback(async () => {
        setLoading(true);
        try {
            const res = await api.get(`/portal/building/list-building/0`, {
                params: {
                    portal: 'hub',
                    id_category: id,
                    no_address: 1,
                    id_corretor: user?.id_corretor ?? '',
                },
            });
            setBuilding(res.data);
        } catch (e: any) {
            console.log(e?.response?.data?.message);
        } finally {
            setLoading(false);
        }
    }, [id, user, api]);

    useEffect(() => { loadBuildings(); }, [loadBuildings]);

    const categoryTitle = categorys.find((cat) => cat.id === Number(id))?.titulo;

    return (
        <Container onScroll={handleScroll}>
            <Header show={show} setShow={setShow} scroll={scrollTop} />
            <ContentHeader>
                <button type="button" onClick={backToTheHome}>
                    <IoChevronBackOutline className="icon" />
                    Voltar
                </button>
                <TitlePage>Resultados da pesquisa: Categoria {categoryTitle}</TitlePage>
                <ComplementHeader />
            </ContentHeader>
            <ContentHeaderMobile>
                <div className="content-button-back-home">
                    <button type="button" onClick={backToTheHome}>
                        <IoChevronBackOutline className="icon" />
                        Voltar
                    </button>
                </div>
                <div className="content-title">
                    <h2>Resultados da pesquisa: Categoria {categoryTitle}</h2>
                </div>
            </ContentHeaderMobile>
            {loading && <LoadSpinner2 />}
            {!loading && (
                <>
                    {building?.length > 0 ? (
                        <div className="content-search">
                            {building.map((b) => (
                                <CardInfo
                                    id={b.id}
                                    id_display={b.id_display}
                                    key={b.id}
                                    descricao={b.descricao}
                                    valor_aluguel={b.is_aluguel}
                                    is_aluguel={b.is_aluguel}
                                    is_venda={b.is_venda}
                                    latitude={b.latitude}
                                    longitude={b.longitude}
                                    periodo_aluguel={b.periodo_aluguel}
                                    valor_venda={b.valor_venda}
                                    arquivos={b.arquivos}
                                    onClick={() =>
                                        navigate(
                                            user
                                                ? `/perfil/${user.id_corretor}/imovel/${b.id}`
                                                : `/imovel/${b.id}`,
                                        )
                                    }
                                    idBuilding={b.id}
                                    is_fixado={b.is_fixado}
                                    is_destaque={b.is_destaque_corretor}
                                    is_lancamento={b.is_lancamento}
                                    is_condominio={b.is_condominio}
                                    bairro={b.bairro}
                                    cidade={b.cidade}
                                    ap_bloco={b.ap_bloco}
                                    ap_numero={b.ap_numero}
                                />
                            ))}
                        </div>
                    ) : (
                        <div className="no-result">
                            <SadAnimation />
                            <p>Nenhum item encontrado em sua busca.</p>
                        </div>
                    )}
                </>
            )}
            <GoToTop />
            <Footer />
        </Container>
    );
}
